import { AfterViewInit, Directive, ElementRef, OnDestroy, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appClamp]'
})
export class ClampDirective implements AfterViewInit, OnDestroy {

  @Output() clamped = new EventEmitter<boolean>();
  private observer!: ResizeObserver;

  constructor(private el: ElementRef<HTMLElement>) { }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  ngAfterViewInit(): void {
    const element = this.el.nativeElement;
    this.observer = new ResizeObserver(() => {
      this.emitClampState(element);
    });

    this.observer.observe(element);
    queueMicrotask(() => this.emitClampState(element));
  }

  private emitClampState(element: HTMLElement): void {
    const isClamped = element.scrollHeight > element.clientHeight;
    this.clamped.emit(isClamped);
  }

}
